import { render, staticRenderFns } from "./Rfid.vue?vue&type=template&id=6f85e1aa&scoped=true&"
import script from "./Rfid.vue?vue&type=script&lang=js&"
export * from "./Rfid.vue?vue&type=script&lang=js&"
import style0 from "./Rfid.vue?vue&type=style&index=0&id=6f85e1aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85e1aa",
  null
  
)

export default component.exports